import { booking, cancelledBookings } from '@assets/icons'
import ActiveBookings from '@commons/bookings/active'
import CompletedBookings from '@commons/bookings/completed'
import DashboardCard from '@commons/cards/dashboard'
import Column from '@components/column'
import Tab from '@components/tabs'
import Title from '@components/title'
import React, { Fragment } from 'react'
import CancellationRequest from './cancellation-request'
import PendingRefund from './pending-refund'
import BookingTravelInquiry from '@pages/admin/bookings/travel-inquiry'

const cardConfig = [
  {
    key: 'totalBookings',
    title: 'Total Bookings',
    icon: booking,
    isUp: true,
    link: '/admin/bookings',
  },
  {
    key: 'totalActiveBooking',
    title: 'Active Bookings',
    icon: booking,
    isUp: true,
    link: '/admin/bookings?tab=Active%20Bookings',
  },
  {
    key: 'totalCancelledBooking',
    title: 'Cancelled Bookings',
    icon: cancelledBookings,
    isUp: false,
    link: '/admin/bookings?tab=Cancelled%20Bookings',
  },
  {
    key: 'totalCompletedBooking',
    title: 'Completed Bookings',
    icon: booking,
    isUp: false,
    link: '/admin/bookings?tab=Completed%20Bookings',
  },
]
const Bookings = () => {
  const items = [
    { label: 'Active Bookings', component: ActiveBookings },
    { label: 'Completed Bookings', component: CompletedBookings },
    { label: 'Cancellation Requests', component: CancellationRequest },

    { label: 'Pending Refund', component: PendingRefund },
    { label: 'Travel Inquiry', component: BookingTravelInquiry },
  ]
  return (
    <Fragment>
      <Column>
        <DashboardCard cardConfig={cardConfig} />
        <Title textone="Bookings" texttwo="Management" />
        <Tab items={items} />
      </Column>
    </Fragment>
  )
}

export default Bookings
